import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {Team} from "@teammood/team";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { TranslateModule, TranslateService } from "@ngx-translate/core";


@Component({
    selector: 'team-members-import-dialog',
    templateUrl: './team-members-import-dialog.component.html',
    styleUrls: ['./team-members-import-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    MatDialogModule
]
})
export class TeamMembersImportDialogComponent implements OnInit{
    email_subject: string;
    email_body: string;
    excel_template_url: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {team: Team},
        public dialogRef: MatDialogRef<TeamMembersImportDialogComponent, Team>,
        private translate: TranslateService,
    ) { }

    ngOnInit() {
        this.excel_template_url = 'https://app.teammood.com/assets/resources/templates/' + this.translate.instant('template_filename');
        this.email_subject = this.translate.instant('excel_template_email_subject') + ' ' + this.data.team.id;
        this.email_body = this.translate.instant('excel_template_email_body');
    }

    close() {
        this.dialogRef.close();
    }
}